import { render, staticRenderFns } from "./InputDefault.vue?vue&type=template&id=187dd1d8&"
import script from "./InputDefault.vue?vue&type=script&lang=js&"
export * from "./InputDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports